import { Dialog, DialogClose, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import { Button } from "components/ui/button";
import { Ellipsis } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { profileVerified } from "assets";
import { Card } from "components/ui/card";

import { t } from "i18next";
import { useState } from "react";
import SearchBar from "components/app/search-bar/SearchBar";

export default function DialogSeeMoreShop({ userShop }: any) {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState<string>("");

  const filteredShops = userShop?.filter((shop: any) => shop.shop_name.toLowerCase().includes(searchText.toLowerCase()));

  const getLocalUser: any = localStorage.getItem("user");
  const localUser = JSON.parse(getLocalUser);

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="flex items-center justify-start flex-row cursor-pointer hover:bg-slate-200 dark:bg-background dark:hover:bg-slate-900 w-full p-2 rounded-lg">
          <div className="w-8 h-8 rounded-full border flex justify-center items-center bg-gray-200 dark:bg-background dark:hover:bg-slate-900">
            <Ellipsis />
          </div>
          <p className="ml-2 font-medium ">{t("See more shops")}</p>
        </button>
      </DialogTrigger>
      <DialogContent className="z-50 max-w-[300px] md:max-w-[500px] lg:max-w-[700px]">
        <DialogHeader>
          <DialogTitle>{t("See more shops")}</DialogTitle>
          <DialogDescription>Explore all available shops in one place.</DialogDescription>
        </DialogHeader>
        <div>
          <div className="mt-4">
            <SearchBar name="SearhAccount" onValueChange={(result) => setSearchText(result)} />
          </div>
          <div onWheel={(e) => e.stopPropagation()} className="h-[400px] max-w-[300px] md:max-w-[500px] lg:max-w-[700px] mt-4">
            {filteredShops ? (
              <div id="scrollableDiv" className="h-[400px] overflow-y-auto custom-scrollbar">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-20">
                  {filteredShops?.map((user: any) => {
                    return (
                      <Card key={user.shop_id} className="rounded-md space-y-2">
                        <div className="cursor-pointer h-full relative overflow-hidden">
                          {user.status === "Unpublished" && (
                            <div className="absolute z-10 top-0 rounded-bl-md rounded-tr-md  right-0 bg-red-700 p-2 text-white text-center font-sans py-0.5 opacity-80 flex items-center">
                              <span className="text-sm">{user.status}</span>
                            </div>
                          )}
                          <DialogClose className="h-full w-full">
                            <div className="flex flex-col h-full w-full justify-between">
                              <div
                                onClick={() => {
                                  localUser.last_active_shop_id = user?.shop_id;
                                  localStorage.setItem("user", JSON.stringify(localUser));
                                  navigate(`/shop-detail?id=${user?.shop_id}`);
                                }}
                              >
                                <ImageUrlProfile className="w-full object-cover h-[200px] rounded-t-md" user={user} isThumbnail={false} />
                                {/* Name */}
                                <div className="p-2">
                                  <div className="flex">
                                    <h1 className="font-semibold text-lg line-clamp-1">{user?.shop_name}</h1>
                                    {user?.is_verified === "Yes" ? (
                                      <div>
                                        <div className="flex items-center justify-center pt-0.5 ml-1">
                                          <img src={profileVerified} style={{ width: 24, height: 24 }} alt="" />
                                        </div>
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <p className={`line-clamp-1 ${user?.description === "" ? "invisible" : ""}`}>{user?.description !== "" ? user?.description : "NoBio"}</p>
                                </div>
                              </div>
                              <div className="grid grid-cols-1 p-2">
                                <Button
                                  onClick={() => {
                                    navigate(`/shop-detail?id=${user?.shop_id}`);
                                  }}
                                  size={"sm"}
                                  className="text-white"
                                >
                                  View Shop
                                </Button>
                              </div>
                            </div>
                          </DialogClose>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
